import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "v2_table_paging_prev",
  "use": "v2_table_paging_prev-usage",
  "viewBox": "0 0 6 10",
  "content": "<symbol viewBox=\"0 0 6 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"v2_table_paging_prev\">\n<path d=\"M4.625 1.4585L0.875 5.2085L4.625 8.9585\" stroke=\"#9B9B9B\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol